import CryptoJS from "crypto-js";
import { ISMENUCOLLAPSED, RETAIL_USER, USER_TIMEOUT } from "src/constants/localStorage";
import { ILoggedUser } from "../../models/Authentication/Authentication.models";

const initAuthState: ILoggedUser = {
  user: null,
  logged: false,
};

export const getAuthUser = (): ILoggedUser => {
  const encryptedAuth = localStorage.getItem(RETAIL_USER);
  if (!encryptedAuth) return initAuthState;

  const bytes = CryptoJS.AES.decrypt(
    encryptedAuth,
    process.env.REACT_APP_CRYPTO_SALT || ""
  );

  try {
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch {
    return initAuthState;
  }
};

export const setAuthUser = (auth: ILoggedUser): void => {
  const encryptedAuth = CryptoJS.AES.encrypt(
    JSON.stringify(auth),
    process.env.REACT_APP_CRYPTO_SALT || ""
  ).toString();
  localStorage.setItem(RETAIL_USER, encryptedAuth);

  const encryptedAuthISMENUCOLLAPSED = localStorage.getItem(ISMENUCOLLAPSED);
  if (!encryptedAuthISMENUCOLLAPSED) 
    localStorage.setItem(ISMENUCOLLAPSED, "false");
};

export const removeAuthUser = (): void => {
  localStorage.removeItem(RETAIL_USER);
  localStorage.removeItem(USER_TIMEOUT);
  sessionStorage.removeItem('invoice_client');
};
